
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/[category]",
      function () {
        return require("private-next-pages/help-centre/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/[category]"])
      });
    }
  